import { QUESTION_TYPE_SPECS } from "../../../services/terrain/validation.js";

export function flattenQuestions(definition) {
  const result = [];
  (definition.sections || []).forEach((section, sectionIndex) => {
    (section.questions || []).forEach((question, questionIndex) => result.push({ question, section, sectionIndex, questionIndex }));
  });
  return result;
}

export function eligibleControllers(definition, targetSectionId, targetQuestionId = null) {
  const sections = definition.sections || [];
  const targetSectionIndex = sections.findIndex((section) => section.sectionId === targetSectionId);
  const flattened = flattenQuestions(definition);
  const targetFlatIndex = targetQuestionId ? flattened.findIndex((entry) => entry.question.questionId === targetQuestionId) : Number.MAX_SAFE_INTEGER;
  return flattened.filter((entry, flatIndex) => {
    const spec = QUESTION_TYPE_SPECS[entry.question.type];
    if (!spec || !spec.operators.length || entry.question.visibility || entry.section.visibility) return false;
    if ((entry.question.type === "singleSelect" || entry.question.type === "multiSelect") && !(entry.question.options || []).length) return false;
    return targetQuestionId ? flatIndex < targetFlatIndex : entry.sectionIndex < targetSectionIndex;
  }).map((entry) => entry.question);
}

export function defaultConditionValues(question, operator) {
  if (["isEmpty", "isNotEmpty", "isChecked", "isNotChecked"].includes(operator)) return [];
  if (question.type === "singleSelect" || question.type === "multiSelect") return question.options && question.options[0] ? [question.options[0].optionId] : [];
  if (question.type === "number") return [0];
  if (question.type === "date") return [new Date().toISOString().slice(0, 10)];
  return [""];
}

export function dependencyErrors(definition) {
  const entries = flattenQuestions(definition);
  const positions = new Map(entries.map((entry, index) => [entry.question.questionId, { ...entry, index }]));
  const errors = [];
  const check = (condition, target, sectionIndex, targetIndex, isSection) => {
    const ref = positions.get(condition.questionId);
    if (!ref) return errors.push(`${target} depende de una pregunta que ya no existe.`);
    if ((isSection && ref.sectionIndex >= sectionIndex) || (!isSection && ref.index >= targetIndex)) return errors.push(`${target} debe depender de una pregunta anterior.`);
    if (ref.question.visibility || ref.section.visibility) return errors.push(`${target} excede la profundidad máxima de un nivel.`);
    const spec = QUESTION_TYPE_SPECS[ref.question.type];
    if (!spec || !spec.operators.includes(condition.operator)) return errors.push(`${target} usa un operador incompatible con su controladora.`);
    const optionTypes = ["singleSelect", "multiSelect"];
    if (optionTypes.includes(ref.question.type)) {
      const ids = new Set((ref.question.options || []).map((option) => option.optionId));
      if ((condition.values || []).some((value) => !ids.has(value))) errors.push(`${target} referencia una opción que ya no existe.`);
    }
  };
  (definition.sections || []).forEach((section, sectionIndex) => {
    if (section.visibility) check(section.visibility, `La sección «${section.title || section.sectionId}»`, sectionIndex, -1, true);
    (section.questions || []).forEach((question) => {
      if (!question.visibility) return;
      if (section.visibility) errors.push(`La pregunta «${question.label}» no puede tener otra condición dentro de una sección condicional.`);
      const targetIndex = positions.get(question.questionId).index;
      check(question.visibility, `La pregunta «${question.label || question.questionId}»`, sectionIndex, targetIndex, false);
    });
  });
  return errors;
}

export function blocksMutation(before, after) {
  const previous = new Set(dependencyErrors(before));
  return dependencyErrors(after).filter((error) => !previous.has(error));
}
